import { change } from 'redux-form'
import React from 'react'
import { compose, bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FormDateInput from 'tfs.form-date-input'
import { validateDate } from 'tfs.front-end-utils/dates'

import { SeatTradeSearchResultsFormName } from '../../config/forms'
import constants from '../../config/constants'

import { v1requestTourOperators } from '../../actions/tourOperators'
import { v1requestSeatTradeSearchResults } from '../../actions/seatTrade'
import {
  v1setDepartureAirport,
  v1setArrivalAirport,
  v1setSearch,
  v1resetSearchResults,
} from '../../actions/search'

import componentCanCrash from '../../utils/components/componentCanCrash'
import getLabels from '../../utils/getLabels'
import getFormValues from '../../utils/getFormValues'
import { moment, dateFromFrontEndToBackEndFormat } from '../../utils/dates'

import AirportsInput from '../AirportsInput'

import SeatTrade from '../../components/SeatTrade'

const today = new Date().toISOString().split('T')[0]

export const fields = [
  {
    label: getLabels('from'),
    type: 'text',
    name: 'departureAirport',
    component: AirportsInput,
    required: true,
    autocomplete: 'off',
    elementRef: React.createRef(),
    placeholder: getLabels('departure_airport'),
  },
  {
    label: getLabels('to'),
    type: 'text',
    name: 'arrivalAirport',
    component: AirportsInput,
    required: true,
    autocomplete: 'off',
    elementRef: React.createRef(),
    placeholder: getLabels('arrival_airport'),
  },
  {
    label: getLabels('start_date'),
    type: 'text',
    name: 'startDate',
    component: FormDateInput,
    min: today,
    required: true,
    elementRef: React.createRef(),
    placeholder: getLabels('start_date'),
  },
  {
    label: getLabels('end_date'),
    type: 'text',
    name: 'endDate',
    component: FormDateInput,
    min: today,
    required: true,
    elementRef: React.createRef(),
    placeholder: getLabels('end_date'),
  },
]

export const mapStateToProps = state => {
  const {
    v1tourOperators: { filteredTourOperators: tourOperators },
    v1seatTrade: {
      isRequestCompleted: seatTradeIsRequestCompleted,
      isFetching: seatTradeIsFetching,
      seatsAreBeingTraded,
    },
  } = state

  return {
    userCustomTopCode: state.v1user.customTOPCode || state.v1user.topCode,
    tourOperators,
    isFetching: seatTradeIsFetching,
    seatTradeIsRequestCompleted,
    seatTradeIsFetching,
    fetchTourOperators:
      tourOperators &&
      !tourOperators.isRequestCompleted &&
      !tourOperators.isFetching,
    seatsAreBeingTraded,
    fields,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators(
      {
        getTourOperators: v1requestTourOperators,
        v1requestSeatTradeSearchResults,
        v1setDepartureAirport,
        v1setArrivalAirport,
      },
      dispatch
    ),
    resetTouroperatorField: () => {
      dispatch(change(SeatTradeSearchResultsFormName, 'tourOperator', ''))
    },
    resetSearch: () => {
      dispatch(
        v1setSearch({
          departureAirport: '',
          departureAirportSearch: '',
          arrivalAirport: '',
          arrivalAirportSearch: '',
        })
      )

      dispatch(v1resetSearchResults())
    },
    resubmitForm: formValues => {
      dispatch(v1requestSeatTradeSearchResults(formValues))
    },
    onSubmit: event => {
      event.preventDefault()

      const formFields = getFormValues(fields)

      const startDate = validateDate(
        moment,
        formFields.startDate,
        constants.frontEndDateFormat
      )
        ? dateFromFrontEndToBackEndFormat(formFields.startDate)
        : formFields.startDate

      const endDate = validateDate(
        moment,
        formFields.endDate,
        constants.frontEndDateFormat
      )
        ? dateFromFrontEndToBackEndFormat(formFields.endDate)
        : formFields.endDate

      const searchValues = {
        departureAirportId: formFields.departureAirport,
        arrivalAirportId: formFields.arrivalAirport,
        startDate: startDate.replace('/-/g', ''),
        endDate: endDate.replace('/-/g', ''),
      }

      dispatch(v1requestSeatTradeSearchResults(searchValues))
    },
  }
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  componentCanCrash
)(SeatTrade)
